import type { ApiSymbolRow, UpsertSymbolRequest } from '../../types/api';
import { cachedRequest, clearApiCache } from './cache';
import { apiFetch } from './client';

export interface FetchSymbolsOptions {
  q?: string;
  limit?: number;
  offset?: number;
  exchange?: string;
  assetType?: string;
}

export function fetchSymbols(options: FetchSymbolsOptions = {}): Promise<ApiSymbolRow[]> {
  const params = new URLSearchParams();
  if (options.q) params.set('q', options.q);
  if (options.limit) params.set('limit', String(options.limit));
  if (options.offset) params.set('offset', String(options.offset));
  if (options.exchange) params.set('exchange', options.exchange);
  if (options.assetType) params.set('asset_type', options.assetType);
  const query = params.toString();
  const path = query ? `/api/symbols?${query}` as const : '/api/symbols';
  return cachedRequest(`symbols:${query}`, 60_000, () => apiFetch<ApiSymbolRow[]>(path));
}

export async function upsertSymbol(symbol: UpsertSymbolRequest): Promise<ApiSymbolRow> {
  const saved = await apiFetch<ApiSymbolRow>('/api/admin/symbols', {
    method: 'PUT',
    body: JSON.stringify(symbol),
  });
  clearApiCache('symbols:');
  return saved;
}
